var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11208",
    "data-name": "Grupo 11208",
    transform: "translate(-723.566 -1670.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11010",
    "data-name": "Grupo 11010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11009",
    "data-name": "Grupo 11009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13854",
    "data-name": "Caminho 13854",
    d: "M742.166,1676.056h-13.2a.9.9,0,0,0-.9.9v10.5a.9.9,0,0,0,.9.9h2.7v.951a.9.9,0,0,0,1.537.636l1.588-1.587h7.375a.9.9,0,0,0,.9-.9v-10.5A.9.9,0,0,0,742.166,1676.056Zm.3,11.4a.3.3,0,0,1-.3.3h-7.5a.3.3,0,0,0-.212.087l-1.675,1.676a.3.3,0,0,1-.513-.212v-1.251a.3.3,0,0,0-.3-.3h-3a.3.3,0,0,1-.3-.3v-10.5a.3.3,0,0,1,.3-.3h13.2a.3.3,0,0,1,.3.3Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13855",
    "data-name": "Caminho 13855",
    d: "M731.966,1685.956h-1.8a.3.3,0,1,0,0,.6h1.8a.3.3,0,1,0,0-.6Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13856",
    "data-name": "Caminho 13856",
    d: "M731.966,1683.256h-1.8a.3.3,0,1,0,0,.6h1.8a.3.3,0,1,0,0-.6Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13857",
    "data-name": "Caminho 13857",
    d: "M734.066,1680.856a.3.3,0,0,0-.3-.3h-3.6a.3.3,0,1,0,0,.6h3.6A.3.3,0,0,0,734.066,1680.856Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13858",
    "data-name": "Caminho 13858",
    d: "M730.166,1678.456h6.3a.3.3,0,0,0,0-.6h-6.3a.3.3,0,0,0,0,.6Z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11011",
    "data-name": "Grupo 11011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13859",
    "data-name": "Caminho 13859",
    d: "M739.826,1679.131l-4.424,4.425-.836,2.575,2.576-.835,4.424-4.425Zm1.16,1.74-.58.58-1.16-1.16.58-.58Zm-5.313,3.177.977.976-.438.142-.681-.68Zm.2-.382,3.084-3.085.435.435-3.084,3.085Zm.725.725,3.084-3.085.435.436-3.084,3.084Zm-1.208.533.385.384-.569.185Z",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon-comment.f6b9bb846973e94d49ac57f6b6026c28.svg";
export { ForwardRef as ReactComponent };